<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <TabMenu :menuIndex="menuIndex" :menu="menu" />

    <div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      breadcrumb: [
        { name: "车辆管理" },
        { name: "违章管理" },
      ],
      menuIndex: '/vehicle/breakRules/list',
      menu: [
        {
          name: "违章统计",
          path: '/vehicle/breakRules/list',
        },
        {
          name: "违章明细",
          path: '/vehicle/breakRules/detailList',
        },
      ],
    };
  },
  methods: {},
  watch: {
    $route() {
      this.menuIndex = this.$route.path
    },
  },
  mounted() {
    this.menuIndex = this.$route.path
  },
};
</script>